<template lang="pug">
  #alert-panel(:class="panel_state")
    alert-panel-switcher(@clicked="switchPanelState" :panel_state="panel_state")
    .alert-panel-body
      .preloader(v-if="is_loading")
      alert-item(v-for="(alert, i) in alerts"
                 :alert="alert.attributes"
                 @click_close="removeAlert"
                 @click_link="gotoAlertLink"
                 )
</template>

<script>
import AlertPanelSwitcher from "./alertPanelSwitcher";
import AlertItem from "./alertItem";
export default {
name: "alertPanel",
  components: {AlertItem, AlertPanelSwitcher},
  props: {
    role: {
      type: String,
      default: 'user',
    }
  },
  data(){
    return {
      panel_state: 'closed',
      socket_state: 'disconnected',
    }
  },
  computed:{
    alerts(){
      return this.$store.getters[`alerts/allAlerts`];
    },
    list_state(){
      return this.$store.state.alerts.list_state;
    },
    is_loading(){
      return this.list_state === 'loading'
    },

  },
  channels: {
    AlertsChannel: {
      connected() {
        console.log('===== connected!');
        if (this.socket_state === 'diconnected') this.updateMessageList();
        this.socket_state = 'connected'
      },
      rejected() {
        console.log('===== rejected!');
        this.socket_state = 'rejected'
      },
      received(data) {
        let alert = data.alert.data
        console.log('===== received.', data);
        if (data.action === 'new') {
          if (this.panel_state !== 'opened') {
            this.panel_state = 'just_now';
            alert.attributes = Object.assign(alert.attributes, {just_received: true})
          }
          this.$store.commit('alerts/addAlert', alert)
        }
        if (data.action === 'destroy') {
          this.$store.commit('alerts/removeAlert', alert)
        }
      },
      disconnected() {
        console.log('===== disconnected!');
        this.socket_state = 'disconnected'
      },
    },
  },
  beforeMount() {
    this.$store.commit('alerts/setListRole', this.role);
  },
  mounted() {
    this.updateList();
    this.$cable.subscribe({
      channel: 'AlertsChannel',
      room: 'public',
    });
  },
  methods:{
    switchPanelState(){
      if (this.panel_state === 'opened') {
        this.panel_state = 'closed';
      } else {
        this.$store.dispatch('alerts/resetJustReceivedAlert')
        this.panel_state = 'opened';
      }
    },
    updateList(){
      let promise = this.$store.dispatch(`alerts/getAlerts`);
      promise.then(this.listUpdated);
    },
    listUpdated(){
      console.log('alerts::listUpdated')
    },
    removeAlert(alert){
       return this.$store.dispatch('alerts/removeAlert', {id: alert.id});
    },
    gotoAlertLink(alert){
      console.log('click link!');
      let promise = this.removeAlert(alert);
      promise.then(window.location = alert.link)
    },

  },
}
</script>

<style scoped>
  #alert-panel{
    transition: all .3s ease;
    position: fixed;
    top: 0;
    right: -350px;
    z-index: 9999;
    width: 350px;
    height: 100vh;
    background-color: #edf0f3;
  }
  #alert-panel.opened{
    right: 0;
  }

  .alert-panel-body{
    padding: 10px;
    height: 100%;
  }

  #alert-panel.opened .alert-panel-body{
    overflow-y: scroll;
  }

</style>